/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NamespaceRequest } from '../models/NamespaceRequest';
import type { NamespaceResponse } from '../models/NamespaceResponse';
import type { UUID } from '../models/UUID';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NamespaceResourceService {

    /**
     * Creates a namespace and optionally a data source associated with it
     * @param requestBody Namespace object to create
     * @returns NamespaceResponse The requested namespace, along with its associated data source if applicable
     * @throws ApiError
     */
    public static createNamespace(
        requestBody: NamespaceRequest,
    ): CancelablePromise<NamespaceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Fetches all namespaces and, optionally, their associated data sources and or views
     * @param includeDataSources
     * @param includeViews
     * @returns any All namespaces, along with associated data sources and or views
     * @throws ApiError
     */
    public static getNamespaces(
        includeDataSources: boolean = false,
        includeViews: boolean = false,
    ): CancelablePromise<{
        namespaces: Array<NamespaceResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/namespaces/list',
            query: {
                'includeDataSources': includeDataSources,
                'includeViews': includeViews,
            },
        });
    }

    /**
     * Gets a namespace and its associated data sources and or views
     * @param id
     * @param includeDataSources
     * @param includeViews
     * @returns NamespaceResponse The requested namespace, along with its associated data sources and or views
     * @throws ApiError
     */
    public static getNamespace(
        id: UUID,
        includeDataSources: boolean = false,
        includeViews: boolean = false,
    ): CancelablePromise<NamespaceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/namespaces/{id}',
            path: {
                'id': id,
            },
            query: {
                'includeDataSources': includeDataSources,
                'includeViews': includeViews,
            },
        });
    }

    /**
     * Updates a namespace's metadata
     * @param id
     * @param requestBody Namespace object to update
     * @returns NamespaceResponse The updated namespace, along with its associated data sources
     * @throws ApiError
     */
    public static updateNamespace(
        id: UUID,
        requestBody: NamespaceRequest,
    ): CancelablePromise<NamespaceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/namespaces/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a namespace, cascading to its associated resources
     * @param id
     * @returns any 200 if the namespace was deleted properly
     * @throws ApiError
     */
    public static deleteNamespace(
        id: UUID,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/namespaces/{id}',
            path: {
                'id': id,
            },
        });
    }

}
